var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojioneV1FlagForUnitedArabEmirates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.34375 8.25H29V14.2083H6.34375V8.25Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34375 21.0834H24.4688C27.4716 21.0834 29 18.8261 29 16.0417V14.2084H6.34375V21.0834Z",
    fill: "#25333A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4688 0.916626H6.34375V8.24996H29V5.95829C29 3.17392 27.4716 0.916626 24.4688 0.916626Z",
    fill: "#137A08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34375 14.2083V0.916626H4.53125C1.52839 0.916626 0 3.17392 0 5.95829V16.0416C0 18.826 1.52839 21.0833 4.53125 21.0833H6.34375V14.2083Z",
    fill: "#EC1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojioneV1FlagForUnitedArabEmirates);
export default __webpack_public_path__ + "static/media/emojione-v1_flag-for-united-arab-emirates.1f22862a2a5293d5cd13599d2dde758f.svg";
export { ForwardRef as ReactComponent };